export var PesScoreSuggestionKey;
(function (PesScoreSuggestionKey) {
    PesScoreSuggestionKey["MANAGER_HAVE_NOT_SENT_EMPLOYEE"] = "MANAGER_HAVE_NOT_SENT_EMPLOYEE";
    PesScoreSuggestionKey["EMPLOYEE_HAVE_NOT_SENT_PEER"] = "EMPLOYEE_HAVE_NOT_SENT_PEER";
    PesScoreSuggestionKey["USER_HAVE_NOT_SENT_FEEDBACK"] = "USER_HAVE_NOT_SENT_FEEDBACK";
})(PesScoreSuggestionKey || (PesScoreSuggestionKey = {}));
